const config = require('../../config').default;
const provider = require(`./${config.authProvider}`).default;
export default provider;
